import Metatags from '@components/common/Metatags';
import StoreLocatorMap from '@components/storelocator/StoreLocatorMap';
import { StoreLocatorActionTypes } from '@state/features/common.types';
import { currentStoreSelector } from '@state/features/storelocator.selectors';
import JsonLd from '@utils/JsonLd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import StoreAvailableServices from './StoreAvailableServices';
import StoreBoutiqueCollections from './StoreBoutiqueCollections';
import StoreBoutiqueInformation from './StoreBoutiqueInformation';
import StoreBoutiquesNearby from './StoreBoutiquesNearby';
import StoreBreadcrumb from './StoreBreadcrumb';
import StoreSummary from './StoreSummary';
const StorePage = (props) => {
    var _a;
    const { store, country, city } = useParams();
    const dispatch = useDispatch();
    useEffect(() => {
        if (store) {
            const slug = `${country}/${city}/${store}`;
            dispatch({ type: StoreLocatorActionTypes.FETCH_STORE_DETAILS, payload: slug });
        }
    }, []);
    const storedetail = useSelector(currentStoreSelector);
    if (!storedetail) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "store-page" },
        React.createElement(Metatags, { pageMetaTags: storedetail.pageMetaTags, meta: storedetail.meta }),
        React.createElement(JsonLd, { data: {
                '@context': 'https://schema.org',
                '@type': 'Store',
                image: storedetail.image && false ? [storedetail.image] : [props.storedetailimage],
                // doesn't have to be a valid url, only a stable ID with the form of an url
                '@id': `http://store.moncler.com/${storedetail.ID}`,
                name: storedetail.name,
                // TODO openingHoursSpecification
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: storedetail.address1,
                    addressLocality: storedetail.city,
                    addressRegion: storedetail.stateCode,
                    postalCode: storedetail.postalCode,
                    addressCountry: (_a = storedetail.countryCode) === null || _a === void 0 ? void 0 : _a.value,
                },
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: storedetail.latitude,
                    longitude: storedetail.longitude,
                },
                url: `${window.homeurl}/storelocator/${storedetail.slug}`,
                telephone: storedetail.phone,
            } }),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-sm-8" },
                    React.createElement("div", { className: "store-detail__title" },
                        React.createElement("p", null,
                            "MONCLER ",
                            storedetail.city),
                        React.createElement("h1", null, storedetail.name)))),
            React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-sm-8" },
                    React.createElement(StoreBreadcrumb, { store: storedetail }))),
            storedetail.image && (React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-sm-8" },
                    React.createElement("div", { className: "picture" },
                        React.createElement("img", { src: storedetail.image, alt: "" }))))),
            React.createElement("div", { className: "row justify-center spaced-row" },
                React.createElement("div", { className: "col-sm-8 col-lg-3" },
                    React.createElement(StoreSummary, { store: storedetail, inPage: true }),
                    React.createElement(StoreBoutiqueInformation, Object.assign({ store: storedetail }, props)),
                    React.createElement(StoreBoutiqueCollections, { collections: storedetail.storeCollections })),
                React.createElement("div", { className: "col-sm-8 col-lg-5" },
                    React.createElement(StoreLocatorMap, Object.assign({}, props, { localMap: true, stores: [storedetail], currentStore: storedetail })))),
            storedetail.storeEvents && (React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-sm-8" },
                    React.createElement("div", { className: "store-quote" },
                        React.createElement("img", { src: "/on/demandware.static/-/Sites/default/images/background-quote.jpeg", alt: "store quote" }),
                        React.createElement("div", { className: "quote-wrapper", dangerouslySetInnerHTML: { __html: storedetail.storeEvents } }))))),
            storedetail.hasInStoreServices && (React.createElement("div", { className: "row justify-center" },
                React.createElement("div", { className: "col-sm-8" },
                    React.createElement(StoreAvailableServices, { services: storedetail.storeServices, inPage: true })))),
            storedetail.hasNearbyStores && React.createElement(StoreBoutiquesNearby, Object.assign({}, props, { stores: storedetail.nearbyStores })))));
};
export default StorePage;
